import styled from 'styled-components';

export const SpinnerContainer = styled.div`
width: 100%;
height: 100vh;
display: flex;
justify-content: center;
align-items: center;
`;

export const PageCategoryContent = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;

    @media (min-width: 768px) {
        justify-content: flex-start;
    }
`;

export const ContentItem = styled.div`
    text-decoration: none !important;
    width: 220px;
    height: 282px;
    margin-bottom: 1rem;
    cursor: pointer;
    
    @media (min-width: 768px) {
        margin: 5px;
    }
    @media (min-width: 1080px) {
        margin: 15px;
    }

    img {
        display: block;
        width: 215px;
        height: 282px;
    }
`;